import React from "react";
import {Box, Grid} from "@mui/material";
import MatchHighlightFilters from "./AggregationFilterComponents/MatchHighlightFilters";
import MatchHighlightParams from "./AggregationParamsComponents/MatchHighlightParams";
import {FilterOption} from "../../../../types/filterTypes";

interface MatchHighlightHeaderProps{
    match: FilterOption | null
    setFootballMatch: (footballMatch: FilterOption | null) => void;
    durationMin: number;
    durationMax: number;
    onDurationChange: (type : 'min' | 'max', value: number) => void
    onCompetitionChange: (competition: FilterOption) => void;
    competition: FilterOption | null
    disabled?: boolean
    presetMode?: boolean
}

const MatchHighlightHeader: React.FC<MatchHighlightHeaderProps> = ({match, competition, setFootballMatch, durationMin, durationMax, onDurationChange, onCompetitionChange, disabled = false, presetMode}) => {
    return (
        <Box sx={{ py: 2 }} data-tour={"match-highlight-header"}>
            <Grid container spacing={2}>
                <Grid size={3}>
                    <MatchHighlightFilters
                        disabled={disabled}
                        presetMode={presetMode}
                        competition={competition}
                        event={match}
                        onCompetitionChange={onCompetitionChange}
                        onEventChange={setFootballMatch}
                    />
                </Grid>
                <Grid size={9} display={'flex'} alignItems="center" data-tour={"content-aggregation-time-params"}>
                    <MatchHighlightParams
                        durationMin={durationMin}
                        durationMax={durationMax}
                        onDurationChange={onDurationChange}
                    />
                </Grid>
            </Grid>
        </Box>

    )
}

export default MatchHighlightHeader;